import axios from 'axios';

const api = axios.create({
    baseURL: 'https://realwork.pro/api', // Твой URL бэкенда
});

// ДИНАМИЧЕСКИЙ ПЕРЕХВАТЧИК: срабатывает ПЕРЕД каждым запросом
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Читаем актуальный токен из памяти

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else {
            console.warn("Токен отсутствует в localStorage под ключом 'token'!");
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;